/**
 * Debounces a function
 *
 * @param {Function} func     The function to debounce
 * @param {Integer}  interval The interval, in milliseconds
 * @return {Function}         The function debounced
 */
const debounce = ( func, interval = 300 ) => {
	let timer;

	return ( ...args ) => {
		clearTimeout( timer );

		timer = setTimeout( () => {
			func.apply(this, args);
		}, interval );
	};
};

export default debounce;
